// extracted by mini-css-extract-plugin
export var copyableField = "_mm-4";
export var customerBadge = "_mm-0";
export var customerInfoTitle = "_mm-2";
export var details = "_mm-1";
export var dropdownContainer = "_mm-5";
export var dropdownImage = "_mm-6";
export var editAssigneeForm = "_mm-a";
export var editButton = "_mm-3";
export var email = "_mm-7";
export var hidden = "_mm-d";
export var input = "_mm-8";
export var saveButton = "_mm-b";
export var shopifyIcon = "_mm-c";
export var suggestionBadge = "_mm-e";
export var suggestionText = "_mm-f";
export var username = "_mm-9";